import { render, staticRenderFns } from "./ManagerCreate.vue?vue&type=template&id=66a96e38&"
import script from "./ManagerCreate.vue?vue&type=script&lang=js&"
export * from "./ManagerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports